/**
 * TasksWorkspace - Background Task Monitoring
 *
 * Wraps the existing FlexTaskMonitor for task management.
 * Single view showing task status, history, and controls.
 *
 * Features:
 * - Real-time task status monitoring
 * - Task history and logs
 * - Cancellation and retry controls
 * - Filtering and search
 */

import React from 'react';
import { Box } from '@mui/material';
import FlexTaskMonitor from '../../FlexStudio/FlexTaskMonitor';

/**
 * TasksWorkspace Component
 *
 * @param {Object} colors - Theme colors object (passed for consistency)
 */
const TasksWorkspace = ({ colors }) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: colors.background,
        overflow: 'hidden',
      }}
    >
      <FlexTaskMonitor
        isCollapsed={false}
        onToggleCollapse={() => {}}
        standalone={true}
      />
    </Box>
  );
};

export default TasksWorkspace;
